import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import clsx from 'clsx';
import Card from '@material-ui/core/Card';
import CardHeader from '@material-ui/core/CardHeader';
import firebase from "firebase/app";
import 'firebase/firestore';
import CenterFocusWeakIcon from '@material-ui/icons/CenterFocusWeak';
import CancelIcon from '@material-ui/icons/Cancel';
import GridOffIcon from '@material-ui/icons/GridOff';
import CardContent from '@material-ui/core/CardContent';
import CardActions from '@material-ui/core/CardActions';
import Collapse from '@material-ui/core/Collapse';
import Avatar from '@material-ui/core/Avatar';
import IconButton from '@material-ui/core/IconButton';
import Typography from '@material-ui/core/Typography';
import { red } from '@material-ui/core/colors';
import CreateIcon from '@material-ui/icons/Create';
import TextField from '@material-ui/core/TextField';
import Autocomplete from '@material-ui/lab/Autocomplete';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import DriveEtaIcon from '@material-ui/icons/DriveEta';
import FormGroup from '@material-ui/core/FormGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Switch from '@material-ui/core/Switch';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import SaveIcon from '@material-ui/icons/Save';
import DepartureBoardIcon from '@material-ui/icons/DepartureBoard';//em transito
import EventAvailableIcon from '@material-ui/icons/EventAvailable';//deferidas
import EventBusyIcon from '@material-ui/icons/EventBusy';//inderefiras
import EventNoteIcon from '@material-ui/icons/EventNote';//analise
import EventIcon from '@material-ui/icons/Event';//concluidas
import HistoryIcon from '@material-ui/icons/History';
import { deepOrange, green } from '@material-ui/core/colors';
import CallMissedOutgoingIcon from '@material-ui/icons/CallMissedOutgoing';
import Tooltip from '@material-ui/core/Tooltip';
import Cardtransferir from './cardtransferir';
import Grid from '@material-ui/core/Grid';
import Cardselectmotora from './cardselectmotoraecia';
import EmojiTransportationIcon from '@material-ui/icons/EmojiTransportation';
import { dateTimePickerDefaultProps } from '@material-ui/pickers/constants/prop-types';
import { DateTimePicker } from '@material-ui/pickers';
import Cardmap from './apmap';
import Cardmaproute from './aproute';
import { ControlPointDuplicateOutlined } from '@material-ui/icons';
import Link from '@material-ui/core/Link';
import AssignmentTurnedInIcon from '@material-ui/icons/AssignmentTurnedIn';
import Mapdialog from './mapdialog';
import ExploreIcon from '@material-ui/icons/Explore';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import Button from '@material-ui/core/Button';
import Impressaosolicitacao from '../util/diariobordo';
import AssignmentIcon from '@material-ui/icons/Assignment';
import { Impressaoviagem } from '../util/Impressaoviagem';
import { Impressaointerno } from '../util/Impressaointerno';
import { Impressaootdeferido } from '../util/Impressaootdeferido';
import Checkbox from '@material-ui/core/Checkbox';
import FormLabel from '@material-ui/core/FormLabel';
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
pdfMake.vfs = pdfFonts.pdfMake.vfs;
const useStyles = makeStyles((theme) => ({
  root: {
    marginTop: theme.spacing(1),
    alignContent:'LEFT',
  },
  media: {
    height: 0,
    paddingTop: '56.25%', // 16:9
  },
  expand: {
    transform: 'rotate(0deg)',
    marginLeft: 'auto',
    transition: theme.transitions.create('transform', {
      duration: theme.transitions.duration.shortest,
    }),
  },
  expandOpen: {
    transform: 'rotate(180deg)',
  },
  datas:{
    alignItems: 'center',
    marginTop: theme.spacing(2),

  },
  rounded: {
    color: green[500],
    //backgroundColor: green[500],
  },
  rounded2: {
    color: red[500],
    //backgroundColor: green[500],
  },
  rounded3: {
    color: green[500],
    //backgroundColor: green[500],
  },
  avatar: {
    backgroundColor: red[500],
  },
}));

//****************************************************************carregar tipos veiculo***************** */

var datar='';
var hretorno= '';
var ag;
 export default function RecipeReviewCard(props) {
  const[propsretorno, setapropsretorno]=React.useState('');
  //***************************** */
  
  const visualizarsolicitacao = () => {
    console.log(props);
  //var rel = Impressaosolicitacao(props)
    //pdfMake.createPdf(Impressaosolicitacao).open({}, window.open('', '_blank'));
    //rel.criarpdf();
    if(props.props[0].tipodeslocamento==2){
      const classeImpressaov = new Impressaoviagem(props);
      const documentov = classeImpressaov.GerarDocumento();
      pdfMake.createPdf(documentov).open({}, window.open('', '_blank'));
    }else{
      if(props.props[0].tipodeslocamento==1){
        const classeImpressao = new Impressaointerno(props);
        const documento = classeImpressao.GerarDocumento();
        pdfMake.createPdf(documento).open({}, window.open('', '_blank'));
      }
    }
    
  }

  //************************ordem de trânsito */

  const visualizarordem = () => {
    console.log(props);
  //var rel = Impressaosolicitacao(props)
    //pdfMake.createPdf(Impressaosolicitacao).open({}, window.open('', '_blank'));
    //rel.criarpdf();
    
      const classeImpressaoot = new Impressaootdeferido(props);
      const documentoot = classeImpressaoot.GerarDocumento();
      pdfMake.createPdf(documentoot).open({}, window.open('', '_blank'));
    
    
    
  }
  //***************************** */

  const[stid, setaid]=React.useState('');
  const[datahoraretorno, setadatahoraretorno]=React.useState('');
  const[dataretornoreal, setadataretornoreal]=React.useState('');
  const[datachegadaretorno, setadatachegadaretorno]=React.useState('');
  const[datahorasaida, setadatahorasaida]=React.useState('');
  const[datahorasaidareal, setadatahorasaidareal]=React.useState('');
  const[depsolicitente, setadepsolicitante]=React.useState('');
  const[dsolicitacao, setadsolicitacao]=React.useState('');
  const[nomesolicitante, setanomesolicitante]=React.useState('');
  const[lotacaosolicitante, setalotacaosolicitante]=React.useState('');
  const[telefonesolicitante, setatelefonesolicitante]=React.useState('');
  const[objetivo, setaobjetivo]=React.useState('');
  const[nsolicitacao, setansolicitacao]=React.useState('');
  const[npassageiro, setanpassageiro]=React.useState('');
  const[siapesolicitente, setasiapesolicitente]=React.useState('');
  const[listaparadasvolta, setalistaparadasvolta]=React.useState(['']);
  const[listaparadasida, setalistaparadasida]=React.useState(['']);
  const[listapassageiros, setalistapassageiros]=React.useState(['']);
  const[localdestino, setalocaldestino]=React.useState('');
    const[localsaida, setalocalsaida]=React.useState('');
    const[localdestinomapa, setalocaldestinomapa]=React.useState(['']);
  const[localsaidamapa, setalocalsaidamapa]=React.useState(['']);
  const[geolocalsaidamapa, setageolocalsaidamapa]=React.useState(['']);
  const[temporetorno, setatretorno]=React.useState('');
  const[geolocaldestinomapa, setageolocaldestinomapa]=React.useState(['']);
  const[campisolicitante, setacampisolicitante]=React.useState('');
  const[observacao, setaobservacao]=React.useState('');
  //const[anexos, setaanexos]=React.useState('');
  const[autorizacoes, setaautorizacoes]=React.useState([]);
  const[tipodeslocamento, setatipodeslocamento]=React.useState('');
  const[tipodesl, setatipodesl]=React.useState(0);
  const[nomerespdespesas, setanomerespdespesas]=React.useState('');
  const[fonerespdespesas, setafonerespdespesas]=React.useState('');
  const[stdivdespesas, setastdivdespesas]=React.useState(true);
  const[stdivcontroles, setastdivcontroles]=React.useState(true);
  const[stbttransferir, setastbttransferir]=React.useState(true);
  const[stbtdeferirmento, setastbtdeferirmento]=React.useState(false);
  const[stbtindeferirmento, setastbtindeferirmento]=React.useState(true);
  const[unidadetransferencia, setaunidadetransferencia]=React.useState('');
  const[kilometragem, setakilometragem]=React.useState('');
  const[passageiros, setapassageiros]=React.useState('');
  const[anexo, setaanexo]=React.useState([]);
  const[rdespesas, setardespesas]=React.useState(1);
  const[stvalorkm, setavalorkm]=React.useState('');
  
 
 
//********************objeto veiculo******************* */

const [itemagenda, setitemagenda] = React.useState([]);

var tipodesloc;
var respdesp;
var pagina;
React.useEffect(()=>{
  setitemagenda(props.props);
  console.log("item agend props ", props.props)
},[props])

React.useEffect(() => {
  console.log("item agend props ", props.usertipo)
  
  if(props.pagina==1){
    setastbtindeferi(false);
    if((props.usertipo==3)||(props.usertipo==5)||(props.usertipo==7)){
      setastbtdeferi(false);
    }

    if((props.usertipo==6)||(props.usertipo==7)){
      setastbttransferir(false);
      
    }

  }else{
     if(props.pagina==2){
      setastbtindeferi(false);
      setastbtdeferi(true);
      if((props.usertipo==6)||(props.usertipo==7)){
        setastbttransferir(false);
        
      }
  }else{
    if(props.pagina==3){
      if((props.usertipo==3)||(props.usertipo==5)||(props.usertipo==7)){
        setastbtdeferi(false);
        setastbtindeferi(true);
      }

    }
  }

}







var tr='';
itemagenda.forEach(modelo=>(tr=modelo.temporetorno));
var dt='';
var datar='' ;
itemagenda.forEach(modelo=>(dt=modelo.datahoraretorno));
if (dt!=undefined) {
  setadataretornoreal(dt);
  setatemporetorno(tr,dt);
  datar= new Date(dt.seconds*1000).toLocaleString("pt-BR");
 
}
//
var id='';
itemagenda.forEach(modelo=>(id=modelo.id));
setaid(id);

setadatahoraretorno(datar);
var dts='';
var datas=''
itemagenda.forEach(modelo=>(dts=modelo.datahorasaida));
if (dts!=undefined) {
  setadatahorasaidareal(dts);
  datas= new Date(dts.seconds*1000).toLocaleString("pt-BR");
  
}
setadatahorasaida(datas);
var depsol;
itemagenda.forEach(modelo=>(depsol=modelo.depsolicitacao));
console.log('valor do stateauco ',depsol);
if(depsol!=undefined){
  console.log('valor do stateauco ',depsol[0].nomedepsol);
setadepsolicitante(depsol[0].nomedepsol);
}

itemagenda.forEach(modelo=>(tipodesloc=modelo.tipodeslocamento));
console.log('valor do stateauco ',tipodesloc);
setatipodesl(tipodesloc)
if(tipodesloc==1){
  setatipodeslocamento('Deslocamento Interno')
}else{
  if(tipodesloc==2){
    setatipodeslocamento('Viagem')
   
itemagenda.forEach(modelo=>(respdesp=modelo.respdespesas));
console.log('responsavel' ,respdesp);
if((respdesp!='')||(respdesp!=undefined)){
  setardespesas(respdesp)
}
    var nomerespdesp;
itemagenda.forEach(modelo=>(nomerespdesp=modelo.nomerespdespesas));
setanomerespdespesas(nomerespdesp);
var fonerespdep;
itemagenda.forEach(modelo=>(fonerespdep=modelo.fonerespdespesas));
setafonerespdespesas(fonerespdep);
setastdivdespesas(false);
  }
}

var vkm ='';
itemagenda.forEach(modelo=>(vkm=modelo.valorkmrodado))
setavalorkmrodado(vkm);

var km ='';
itemagenda.forEach(modelo=>(km=modelo.totalkm))
setakilometragem(km);

var ps ='';
var pss='';
itemagenda.forEach(modelo=>(ps=modelo.listapassageiros))
for (let index = 0; index < ps.length; index++) {
  pss = pss  + ps[index].passageiro.nome + ', ';
  console.log("psssss " + ps[index])
  console.log("psssss " , pss)
}
setapassageiros(pss);



var dsol ='';
itemagenda.forEach(modelo=>(dsol=modelo.dsolicitacao))
setadsolicitacao(dsol);
var nomesol=';'
itemagenda.forEach(modelo=>(nomesol=modelo.nomesolicitante))
setanomesolicitante(nomesol);
var cp ='';
itemagenda.forEach(modelo=>(cp=modelo.campisolicitante))
setacampisolicitante(cp);
var telsol = '';
itemagenda.forEach(modelo=>(telsol=modelo.telefonesolicitante))
setatelefonesolicitante(telsol);
var obj = '';
itemagenda.forEach(modelo=>(obj=modelo.objetivo))
setaobjetivo(obj);
var nsol = '';
itemagenda.forEach(modelo=>(nsol=modelo.nsolicitacao))
//setlot(lota);
setansolicitacao(nsol);
var np='';
itemagenda.forEach(modelo=>(np=modelo.npassageiro))
setanpassageiro(np);
var siapesol='';
itemagenda.forEach(modelo=>(siapesol=modelo.siapesolicitente))
setasiapesolicitente(siapesol);
var obs = '';
itemagenda.forEach(modelo=>(obs=modelo.observacao))
setaobservacao(obs);
var aut = '';

itemagenda.forEach(modelo=>(aut=modelo.autorizacoes));
console.log("autorizacoes ",aut)
if((aut!=undefined)&&(aut!='')){
  setaautorizacoes(aut);
}


/*
itemagenda.forEach(modelo=>(listaparadas=modelo.listaparadas))
//setlot(lota);
itemagenda.forEach(modelo=>(listapassageiros=modelo.listapassageiros))
//setlot(lota);
*/
var dest='';
itemagenda.forEach(modelo=>(dest=modelo.localdestino))
setalocaldestinomapa(dest);
setalocaldestino(dest.description);
console.log('destino', localdestino )
var saida='';
itemagenda.forEach(modelo=>(saida=modelo.localsaida));
setalocalsaidamapa(saida);
setalocalsaida(saida.description);

var pida='';
itemagenda.forEach(modelo=>(pida=modelo.listaparadasida));
if((pida!='')&&(pida!=null)&&(pida!=undefined)){
  setalistaparadasida(pida);
}
//setalistaparadasida(pida);
var volta='';
itemagenda.forEach(modelo=>(volta=modelo.listaparadasvolta));
setalistaparadasvolta(volta);

var ane='';
itemagenda.forEach(modelo=>(ane=modelo.anexo));
if((ane!='')&&(ane!=undefined)){
  console.log("arquivo ", ane)
  const storageRef = firebase.storage().ref();
  const storageRefChild = storageRef.child('anexosagenda/' + id + '/' + ane);
  console.log("arquivo ", storageRefChild.name);
  //console.log("arquivo ", input)

  storageRefChild.getDownloadURL().then(function (url) { 
    // O url de serviço pode ser inserido em um <img> 
    //var img = document.getElementById ('muimui'); 
    console.log("arquivo ", url)
    //var img = url;
    setaanexo([{nome: ane, link: url}])
   // var link_item = document.getElementById('download-link')
   // link_item.setAttribute('href', url)
   // alert('uri anexo', img); 

  }) 
  .catch (function (err) { 
    console.log('Anexado'); 
  })


}


 
  var m='';
  itemagenda.forEach(modelo=>(m=modelo.motorista));
  setamotorista(m);
  if((m!='')&&(m!=undefined)){
    setavermotorista(m);
  }
  var v='';
  itemagenda.forEach(modelo=>(v=modelo.veiculo));
  setaveiculo(v);
  if((v!='')&&(v!=undefined)){
    setaverveiculo(v);
  }

},[itemagenda]);

//**********************************pegar anexos */



//*********************///*/
const[stbtdeferi, setastbtdeferi]=React.useState(false);
const[stbtindeferi, setastbtindeferi]=React.useState(false);
const[stbtsalvartranferencia, setastbtsalvartransferencia]=React.useState(true);
const[stbttrans, setastbttrans]=React.useState(false);
const[stdivtrans, setastdivtrans]=React.useState(true);
const[stdivtreferido, setastdivtreferido]=React.useState(true);
const[stdivmotora, setastdivmotora]=React.useState(true);
const[stbtlotar, setastbtlotar]=React.useState(false);
const[stbtsalvarveiculo, setastbtsalvarveiculo]=React.useState(true);
const[kmtotal, setakm]=React.useState();
const[vermotorista, setavermotorista]=React.useState({label:'',telefone:''});
const[verveiculo, setaverveiculo]=React.useState({label:''});
const[stdivrepeticao, setastdivrepeticao]=React.useState(true);
const[segunda, setasegunda]=React.useState(false);
const[terca, setaterca]=React.useState(false);
const[quarta, setaquarta]=React.useState(false);
const[quinta, setaquinta]=React.useState(false);
const[sexta, setasexta]=React.useState(false);
const[sabado, setasabado]=React.useState(false);
const[domingo, setadomingo]=React.useState(false);
const[datarepetir, setadatarepetir]=React.useState('');



//*********************controle dias semana*********** */
const handledom=(event)=>{
  setadomingo(event.target.checked);
}

const handleseg=(event)=>{
  setasegunda(event.target.checked);
}

const handleter=(event)=>{
  setaterca(event.target.checked);
}

const handlequa=(event)=>{
  setaquarta(event.target.checked);
}

const handlequi=(event)=>{
  setaquinta(event.target.checked);
}

const handlesex=(event)=>{
  setasexta(event.target.checked);
}

const handlesab=(event)=>{
  setasabado(event.target.checked);
}


async function handlesalvarepetir(){
 var dayName = [domingo, segunda, terca, quarta,quinta, sexta, sabado];
 var soma=[];
  console.log(domingo);
  console.log(segunda);
  console.log(terca);
  console.log(quarta);
  console.log(quinta);
  console.log(sexta);
  console.log(sabado);
  console.log(datarepetir);
  var dataate = firebase.firestore.Timestamp.fromDate(new Date(datarepetir));
  var ndatap=new Date((dataate.seconds+97200)*1000);
  console.log(ndatap);
  const datapartida = new Date(datahorasaidareal.seconds*1000);
  console.log(datapartida);
  var diasemana= new Date(datahorasaidareal.seconds*1000).getDay();
  
  if(diasemana==0)
    {
      if(dayName[1]){
        soma.push(1);
      }
      if(dayName[2]){
        soma.push(2);
      }
      if(dayName[3]){
        soma.push(3);
      }
      if(dayName[4]){
        soma.push(4);
      }
      if(dayName[5]){
        soma.push(5);
      }
      if(dayName[6]){
        soma.push(6);
      }
      if(dayName[0]){
        soma.push(7);
      }

    }else{
      if(diasemana==1)
    {
      if(dayName[2]){
        soma.push(1);
      }
      if(dayName[3]){
        soma.push(2);
      }
      if(dayName[4]){
        soma.push(3);
      }
      if(dayName[5]){
        soma.push(4);
      }
      if(dayName[6]){
        soma.push(5);
      }
      if(dayName[0]){
        soma.push(6);
      }
      if(dayName[1]){
        soma.push(7);
      }

    }else{
      if(diasemana==0)
    {
      if(dayName[1]){
        soma.push(1);
      }
      if(dayName[2]){
        soma.push(2);
      }
      if(dayName[3]){
        soma.push(3);
      }
      if(dayName[4]){
        soma.push(4);
      }
      if(dayName[5]){
        soma.push(5);
      }
      if(dayName[6]){
        soma.push(6);
      }
      if(dayName[7]){
        soma.push(7);
      }

    }else{
      if(diasemana==2)
    {
      if(dayName[3]){
        soma.push(1);
      }
      if(dayName[4]){
        soma.push(2);
      }
      if(dayName[5]){
        soma.push(3);
      }
      if(dayName[6]){
        soma.push(4);
      }
      if(dayName[0]){
        soma.push(5);
      }
      if(dayName[1]){
        soma.push(6);
      }
      if(dayName[2]){
        soma.push(7);
      }

    }else{
      if(diasemana==3)
    {
      if(dayName[4]){
        soma.push(1);
      }
      if(dayName[5]){
        soma.push(2);
      }
      if(dayName[6]){
        soma.push(3);
      }
      if(dayName[0]){
        soma.push(4);
      }
      if(dayName[1]){
        soma.push(5);
      }
      if(dayName[2]){
        soma.push(6);
      }
      if(dayName[3]){
        soma.push(7);
      }

    }else{
      if(diasemana==4)
    {
      if(dayName[5]){
        soma.push(1);
      }
      if(dayName[6]){
        soma.push(2);
      }
      if(dayName[0]){
        soma.push(3);
      }
      if(dayName[1]){
        soma.push(4);
      }
      if(dayName[2]){
        soma.push(5);
      }
      if(dayName[3]){
        soma.push(6);
      }
      if(dayName[4]){
        soma.push(7);
      }

    }else{
      if(diasemana==5)
    {
      if(dayName[6]){
        soma.push(1);
      }
      if(dayName[0]){
        soma.push(2);
      }
      if(dayName[1]){
        soma.push(3);
      }
      if(dayName[2]){
        soma.push(4);
      }
      if(dayName[3]){
        soma.push(5);
      }
      if(dayName[4]){
        soma.push(6);
      }
      if(dayName[5]){
        soma.push(7);
      }

    }else{
      if(diasemana==6)
    {
      if(dayName[0]){
        soma.push(1);
      }
      if(dayName[1]){
        soma.push(2);
      }
      if(dayName[2]){
        soma.push(3);
      }
      if(dayName[3]){
        soma.push(4);
      }
      if(dayName[4]){
        soma.push(5);
      }
      if(dayName[5]){
        soma.push(6);
      }
      if(dayName[6]){
        soma.push(7);
      }

    }
    }
    }
    }
    }
    }
    }
      
    }
    var agora = datapartida;
    var datasrep=[]
    var fator=0;
    
    while (agora<ndatap) {
      
        
      for (let index = 0; index < soma.length; index++) {
        var fator1 = fator + soma[index];
        var datal = new Date(datahorasaidareal.seconds*1000);
        datal.setDate(datal.getDate() + fator1);
        var datal2= new Date(dataretornoreal.seconds*1000);
        datal2.setDate(datal2.getDate() + fator1);
        agora=datal;
        console.log(agora);
        
        if(agora<=ndatap){
          
          datasrep.push({datahorasaida:datal, datahoraretorno:datal2});

        }
        //fator=fator+7;
        
      }
      fator=fator+7;
    }
   
    console.log(datasrep)
   /* while (condition) {
      
    }*/
  console.log(dayName[diasemana]);
  console.log(soma);
  console.log("datarepetir");

if(datasrep.length>0){
  
  var dir;
  var db = firebase.firestore();
  //console.log("user tipo poxa"+ lotacao + "puta merda q eu sei2");
  var query = await db.collection("agenda").doc(stid).get().
  then((doc) => {
    if (doc.exists) {
   ag=doc.data();
   console.log("Document data:", ag);
    

}

})
.catch(error => {
   console.log('Não encontramos solicitações cadastradas', error);
});

//**************** */

//**************** */

for (let index = 0; index < datasrep.length; index++) {
  var refid='';
  var repthretorno= firebase.firestore.Timestamp.fromDate(new Date(datasrep[index].datahoraretorno));
 // alert (dataretornoreal);
  var tepdatares = new Date(repthretorno.seconds*1000)
  var atraso = ag.temporetorno+300;

  tepdatares.setSeconds(tepdatares.getSeconds() + atraso);
  
  var db3 = await firebase.firestore();
  var docRef2 =  db.collection("agenda").doc();
  ag.datahoraretorno=firebase.firestore.Timestamp.fromDate(new Date(datasrep[index].datahoraretorno))
  ag.datahorasaida=firebase.firestore.Timestamp.fromDate(new Date(datasrep[index].datahorasaida))
  ag.nsolicitacao=ag.nsolicitacao+index;
  var data1= new Date(ag.datahorasaida.seconds*1000);
  console.log(ag);
  console.log("aqui");
  refid = docRef2.id;
  reservarepet(refid,data1,tepdatares);
  mandadirec(refid);
  docRef2.set(ag)
.then(function () {
  
                 
 alert('Solicitação realizada com Sucesso');
}).catch(function (error) {
    var errorMessage = error.message;
console.log('errrrooo ', errorMessage);
  alert(errorMessage);
  })

  

//************** */



//******************* */


}

}
}

async function reservarepet(props, data1, data2){
  var unit1 =  firebase.firestore().collection("veiculos").doc(ag.veiculo.id).collection('reservas').doc(props);
  return unit1.set({ id: props, datainicio:firebase.firestore.Timestamp.fromDate(new Date(data1)),
     datafim:firebase.firestore.Timestamp.fromDate(new Date(data2))})
    //datafim:datar, })
.then(() => {
            //handlereservamotorista();
            var unit2 =  firebase.firestore().collection("usuarios").doc(ag.motorista.id).collection('reservas').doc(props);
            unit2.set({id: props, datainicio:firebase.firestore.Timestamp.fromDate(new Date(data1)),
              datafim:firebase.firestore.Timestamp.fromDate(new Date(data2))})
          .then(() => {
            
          })
          .catch((error) => {
              // The document probably doesn't exist.
              console.error("Error updating document: ", error);
              console.error("Error updating document: ", error);
          });
            //************************** 
  
})
.catch((error) => {
    // The document probably doesn't exist.
    console.error("Error updating document: ", error);
})
}


async function mandadirec(props){
var dir='';
  var db2 = firebase.firestore();
        //console.log("user tipo poxa"+ lotacao + "puta merda q eu sei2");
        var query = await db2.collection("agenda").doc(stid).collection('direcoes').get().
        then(function(querySnapshot) { 
            querySnapshot.forEach(function(doc) {
                
                dir=doc.data()
                console.log(dir);
               
            } )
        }).catch((error) => {
            console.log("Error getting document:", error);
        });

  var unit =  firebase.firestore().collection("agenda").doc(props).collection('direcoes').doc();
 
  unit.set(dir)
.then(() => {
console.log("locsaliza successfully updated!");

})
.catch((error) => {
// The document probably doesn't exist.
console.error("Error updating document: ", error);
}); 
}

//******************************** */








var listaassina 
const handledeferir =()=>{
  
  var assina ={
    idassina:props.user,
    nomeassina:props.usernome,
    siapeassina:props.usersiape,
    acao:'Deferiu'

  }
  
  
  
  listaassina = autorizacoes;
  listaassina.push(assina);
  setaautorizacoes(currentArray => [...currentArray, assina]);
  console.log("Document autorizacao updated!", listaassina);
  
  if(props.usertipo==7){
    var unit = firebase.firestore().collection("agenda").doc(stid);
    return unit.update({status:'deferido',filaunidadetransporte:props.myfila})
  .then(() => {
    console.log("Document successfully updated!");
    setastbtdeferi(true);
    handleassina();
    alert("Solicitação Deferida");
  })
  .catch((error) => {
      // The document probably doesn't exist.
      console.error("Error updating document: ", error);
  });
  }else{
    console.log("Document successfully updated!",props.usertipo );
    console.log("Document successfully updated!",tipodesl );
    console.log("Document successfully updated!",respdesp );
    console.log("Document successfully updated!",props.usertipo );

    if(((props.usertipo==3)&&(tipodesl==1))||((props.usertipo==3)&&((tipodesl==2)&&(rdespesas==1)))){
      console.log("Document successfully updated!");
      var unit = firebase.firestore().collection("agenda").doc(stid);
    return unit.update({fila:props.pulafila,filadepartamento:props.myfila, status:'solicitado'})
  .then(() => {
    console.log("Document successfully updated!");
    setastbtdeferi(true);
    handleassina();
    alert("Solicitação Deferida");
  })
  .catch((error) => {
      // The document probably doesn't exist.
      console.error("Error updating document: ", error);
  });
    }else{
      if((props.usertipo==3)&&((tipodesl==2)&&(rdespesas==2))){
        console.log("Document successfully updated!");
        var unit = firebase.firestore().collection("agenda").doc(stid);
      return unit.update({fila:props.proxfila,filadepartamento:props.myfila, status:'solicitado'})
    .then(() => {
      console.log("Document successfully updated!");
      setastbtdeferi(true);
      handleassina();
      alert("Solicitação Deferida");
    })
    .catch((error) => {
        // The document probably doesn't exist.
        console.error("Error updating document: ", error);
    });

    }else{

      if(props.usertipo==5){
        var unit = firebase.firestore().collection("agenda").doc(stid);
      return unit.update({fila:props.proxfila,filacentroadm:props.myfila, status:'solicitado'})
    .then(() => {
      console.log("Document successfully updated!");
      setastbtdeferi(true);
      handleassina();
      alert("Solicitação Deferida");
    })
    .catch((error) => {
        // The document probably doesn't exist.
        console.error("Error updating document: ", error);
    });

    }

    }
  }

 
}
}

const handleassina=()=>{

  console.log("Document autorizacao aqui!", autorizacoes);
  var unit = firebase.firestore().collection("agenda").doc(stid);
  return unit.update({autorizacoes: listaassina})
.then(() => {
  console.log("Document autorizacao updated!");
})
.catch((error) => {
    // The document probably doesn't exist.
    console.error("Error updating document: ", error);
});
}

const handleindeferir =()=>{

  var assina ={
    idassina:props.user,
    nomeassina:props.usernome,
    siapeassina:props.usersiape,
    acao:'Indeferiu'

  }
  
  
  //setaautorizacoes(currentArray => [...currentArray, assina]);
  listaassina = autorizacoes;
  listaassina.push(assina);
 setaautorizacoes(currentArray => [...currentArray, assina]);
  console.log("Document autorizacao updated!", listaassina);
    if((props.usertipo==7)||(props.usertipo==6)||(props.usertipo==8)||(props.usertipo==9)){

    //var data = new firebase.firestore.Timestamp(datahoraretorno);
    //var data = new Date(datahoraretorno.seconds*1000).toLocaleString("pt-BR");
    //console.log("Document data updated!", data);
    //console.log("Document data updated!", data);
    var unit = firebase.firestore().collection("agenda").doc(stid);
   // return unit.update({dataretornotimestamp:firebase.firestore.Timestamp.fromDate(new Date(datahoraretorno)),
     // datasaidatimestamp:firebase.firestore.Timestamp.fromDate(new Date(datahorasaida))})
    return unit.update({status:'indeferido',filaunidadetransporte:props.myfila})
   
  .then(() => {
    console.log("Document successfully updated!");
    setastbtindeferi(true);
    handleassina();
    botaoliberarreserva();
    alert("Solicitação Indeferida");
  })
  .catch((error) => {
      // The document probably doesn't exist.
      console.error("Error updating document: ", error);
  });
  }else{
    if((props.usertipo==3)||(props.usertipo==2)){
      var unit = firebase.firestore().collection("agenda").doc(stid);
    return unit.update({status:'indeferido',filadepartamento:props.myfila})
  .then(() => {
    console.log("Document successfully updated!");
    setastbtindeferi(true);
    handleassina();
    botaoliberarreserva();
    alert("Solicitação Indeferida");
  })
  .catch((error) => {
      // The document probably doesn't exist.
      console.error("Error updating document: ", error);
  });
    }else{
      if((props.usertipo==5)||(props.usertipo==4)){
        var unit = firebase.firestore().collection("agenda").doc(stid);
      return unit.update({status:'indeferido',filacentroadm:props.myfila})
    .then(() => {
      console.log("Document successfully updated!");
      setastbtdeferi(true);
      handleassina();
      botaoliberarreserva();
      alert("Solicitação Indeferida");
    })
    .catch((error) => {
        // The document probably doesn't exist.
        console.error("Error updating document: ", error);
    });

    }else{
      if(props.usertipo==1){
        var unit = firebase.firestore().collection("agenda").doc(stid);
      return unit.update({status:'indeferido'})
    .then(() => {
      console.log("Document successfully updated!");
      setastbtdeferi(true);
      handleassina();
      botaoliberarreserva();
      alert("Solicitação Indeferida");
    })
    .catch((error) => {
        // The document probably doesn't exist.
        console.error("Error updating document: ", error);
    });

    }

    }
  }
}

 
}
  
/*function transferencia {

  <Cardtransferir setatransferi={tranferencia}/>
  
}*/
const [listatransferi,setalistatransferi]=React.useState([{}])
const handletransferir =()=>{
  //setastbtsalvartransferencia(false);
  setastbtlotar(false);
  setastdivtrans(false);
  setastbttrans(true);
  setastdivmotora(true);
  setastbtsalvarveiculo(true);
  setExpanded(true);
  setalistatransferi([]);
  setalistatransferi(currentArray => [...currentArray, 'um']);

  ///**************** */
  
    

    

 


  //************************** */
  
}






const [stunidadetransfere,setaunidadetrans]=React.useState([{}]);

const setaunidadetransfere=(props)=>{
  setastbtsalvartransferencia(false);
  setaunidadetrans(props);
}

const handlesalvartransferencia=()=>{
if((stunidadetransfere.id!='')&&(stunidadetransfere.id!=null)&&(stunidadetransfere.id!=undefined)){

  setastbtsalvartransferencia(true);
  setastdivtrans(true);
  setaunidadetransferencia(stunidadetransfere.label)
  setastdivtreferido(false);
  setastbtdeferi(true);
  setastbtindeferi(true);
  console.log('putz transferi',stunidadetransfere )
//**************** *

  var assina ={
    idassina:props.user,
    nomeassina:props.usernome,
    siapeassina:props.usersiape,
    acao:'Transferiu para ' + stunidadetransfere.label

  }
  
  
  
  listaassina = autorizacoes;
  listaassina.push(assina);
  setaautorizacoes(currentArray => [...currentArray, assina]);
  console.log("Document autorizacao updated!", listaassina);
  
  
        var unit = firebase.firestore().collection("agenda").doc(stid);
      return unit.update({fila:stunidadetransfere.id})
    .then(() => {
      console.log("Document successfully updated!");
      setastbtdeferi(true);
      handleassina();
      alert("Solicitação Transferida");
    })
    .catch((error) => {
        // The document probably doesn't exist.
        console.error("Error updating document: ", error);
    });
    //************************ */

}else{
alert("Selecione uma Unidade para Transferir")
}
}

const [motorista, setamotorista]=React.useState([{
  id:'', label:''
}]);
const [veiculo, setaveiculo]=React.useState([{
  id:'', label:''
}]);



const [motoratemp,setamotoratemp]=React.useState({id:''});
const [veiculotemp,setaveiculotemp]=React.useState({id:''});

function liberareserva(mt,vc){

  if((mt.id!='')&&(mt.id!=undefined)){
  var db= firebase.firestore();
  var reservaref = db.collection('usuarios').doc(mt.id).collection('reservas').doc(stid)
  .delete().then(() => {
    console.log("Document successfully deleted!");
}).catch((error) => {
    console.error("Error removing document: ", error);
});
  }

  if((vc.id!='')&&(vc.id!=undefined)){
var db2= firebase.firestore();
var reservaref2 = db2.collection('veiculos').doc(vc.id).collection('reservas').doc(stid)
  .delete().then(() => {
    console.log("Document successfully deleted!");
}).catch((error) => {
    console.error("Error removing document: ", error);
});
  }
}



const handlesalvaveiculomotorista=()=>{
  setaveiculo(stlotamotora[0].veiculo);
  setamotorista(stlotamotora[0].motorista);
if(setamotorista!=''){
  setastbtlotar(true);
  setastdivmotora(true);

   //datar = firebase.firestore.Timestamp.fromDate(new Date((temporetorno/1000)));
  


  //var teste = https+'://'+maps.googleapis.com/maps/api/directions/json?origin+'='+Toronto&destination+'='+Montreal&key+'='+'AIzaSyA0RbxlQeRjG7ZPfUSz1e8KV4oWzqm8Ye8';

  //setastdivtrans(true);
  //setaunidadetransferencia(stunidadetransfere.label)
 // setastdivtreferido(false);
  //setastbtdeferi(true);
  //setastbtindeferi(true);
  //console.log('putz transferi',stunidadetransfere )

  
 // console.log('motora' , props[0].veiculo.label);
  //**************** *

  var assina ={
    idassina:props.user,
    nomeassina:props.usernome,
    siapeassina:props.usersiape,
    acao:'Designou o veículo ' +  stlotamotora[0].veiculo.label + ' e o motorista '+  stlotamotora[0].motorista.label

  }
  
  
  
  listaassina = autorizacoes;
  listaassina.push(assina);
 // setaautorizacoes(currentArray => [...currentArray, assina]);
  console.log("Document autorizacao updated!", listaassina);
  
  
        var unit = firebase.firestore().collection("agenda").doc(stid);
      return unit.update({veiculo:stlotamotora[0].veiculo, motorista:stlotamotora[0].motorista, valorkmrodado: stvalorkmrodado, valorkm:stvalorkm })
    .then(() => {
                console.log("Document successfully updated!");
                setastbtdeferi(true);
                handleassina();
              //handlereservaveiculo();
              
              var unit1 = firebase.firestore().collection("veiculos").doc(stlotamotora[0].veiculo.id).collection('reservas').doc(stid);
              return unit1.set({ id: stid, datainicio:datahorasaidareal,
                 datafim:firebase.firestore.Timestamp.fromDate(propsretorno)})
                //datafim:datar, })
            .then(() => {
                        //handlereservamotorista();
                        var unit2 = firebase.firestore().collection("usuarios").doc(stlotamotora[0].motorista.id).collection('reservas').doc(stid);
                        unit2.set({id: stid, datainicio:datahorasaidareal,
                          datafim:firebase.firestore.Timestamp.fromDate(propsretorno)})
                      .then(() => {
                        
                      })
                      .catch((error) => {
                          // The document probably doesn't exist.
                          console.error("Error updating document: ", error);
                          console.error("Error updating document: ", error);
                      });
                        //************************** 
              
            })
            .catch((error) => {
                // The document probably doesn't exist.
                console.error("Error updating document: ", error);
            }),
              liberareserva(motoratemp,veiculotemp);
   })
   .catch((error) => {
       // The document probably doesn't exist.
       console.error("Error updating document: ", error);
       console.error("Error updating document: ", error);
   });
   
     //********************* */
      
    //************************ */

  }else{
    alert("Selecione o veiculo")
  }
}



//const [stveiculo,setaveiculo]=React.useState();
const setatemporetorno=(props, dt)=>{
  //var hretorno = new Date();//dataretornoreal;
  hretorno= new Date(dt.seconds*1000);//.toLocaleString("pt-BR");
 // alert (dataretornoreal);

  var atraso = props+300;

  hretorno.setSeconds(hretorno.getSeconds() + atraso);
  setapropsretorno(hretorno)
  setatretorno(hretorno.toLocaleString("pt-BR"))
 // setadatachegadaretorno(hretorno)
  
  //setadataretornoreal(hretorno)
  //alert (hretorno);
  /*var teste = hretorno;//.getSeconds/1000;
  alert(teste);
  //var tes = firebase.firestore.Timestamp.fromDate(new Date(teste));
  alert(tes);*/
}

const [stvalordespesamotora,setadespesamotora]=React.useState();
const setavalorescategoriamotorista=(props)=>{
  console.log('valor cat' , props);
  console.log('valor cat' , props);

}

const [stvalorkmrodado,setavalorkmrodado]=React.useState();
const setavaloretipoveiculo=(props)=>{
  console.log('valor tipo veiculo' , props[0].valorkmrodado);
  var valorkm= parseFloat(props[0].valorkmrodado);
  setavalorkmrodado(valorkm);
  valorkm = valorkm * kilometragem;
  valorkm=valorkm.toFixed(2)
  
  setavalorkm (valorkm);
 
}


const [stlotamotora,setastlotamotora]=React.useState();
const setaveiculomotora=(props)=>{
  //setastlotamotora(props);
  console.log('motora' , props[0].motorista.label);
  console.log('motora' , props[0].veiculo.label);

  setastlotamotora(props);
  //setaveiculo(veic);
  //console.log('veiculo' , veic)
  setastbtsalvarveiculo(false);

}



      
                    //********************************** */

  const classes = useStyles();
  const [expanded, setExpanded] = React.useState(false);
  const [condicao, setacondicao] = React.useState([]);
  const handleExpandClick = () => {
    setExpanded(!expanded);
    if(expanded){
    
  }};

  //***************************** */

  const handlecancelrepet=()=>{
    setastdivrepeticao(true);

  }
  const handlerepetirdeslocamento =()=>{
    setExpanded(true);
    setastdivrepeticao(false);
    /*setamotoratemp(vermotorista);
    setaveiculotemp(verveiculo);
    console.log(vermotorista);
    console.log(verveiculo);
    setastbtsalvartransferencia(true);
    setastdivtrans(true);
    setastbttrans(false);
    setastdivmotora(false);
    setExpanded(true);
    setastbtlotar(true);
    //setastbtsalvarveiculo(false);
    //setalistatransferi([]);
    //setalistatransferi(currentArray => [...currentArray, 'um']);*/
    
  }
  //************************ */

  const handlelotarveiculo =()=>{
    setamotoratemp(vermotorista);
    setaveiculotemp(verveiculo);
    console.log(vermotorista);
    console.log(verveiculo);
    setastbtsalvartransferencia(true);
    setastdivtrans(true);
    setastbttrans(false);
    setastdivmotora(false);
    setExpanded(true);
    setastbtlotar(true);
    //setastbtsalvarveiculo(false);
    //setalistatransferi([]);
    //setalistatransferi(currentArray => [...currentArray, 'um']);
    
  }

  const botaoliberarreserva=()=>{
    var mt = vermotorista;
    var vt = verveiculo;
    liberareserva(mt,vt);
    setavermotorista({label:'', telefone:''});
    setaverveiculo({label:''})
  
    if((vt.id!='')&&(vt.id!=undefined)){
    var db= firebase.firestore();
      var Ref = db.collection('agenda').doc(stid);
  
  // Remove the 'capital' field from the document
  var remove = Ref.update({
      veiculo: firebase.firestore.FieldValue.delete()
  });
    }
  
    if((mt.id!='')&&(mt.id!=undefined)){
      var db= firebase.firestore();
        var Ref = db.collection('agenda').doc(stid);
    
    // Remove the 'capital' field from the document
    var remove = Ref.update({
        motorista: firebase.firestore.FieldValue.delete()
    });
      }
  
  
  }
  
  const [openitinerariomapa, setaopenitinerariomapa] = React.useState(false);
 
 const handleClickopenitinerariomapa= () => {
  setaopenitinerariomapa(true);
 };

 const handleCloseditinerariomapa = () => {
  setaopenitinerariomapa(false);
 };


 //**************************handle interno livre  */
 const [geodestinolivre, setageodestinolivre] = React.useState({lat:-29.71794617, lng:-53.71221745});
 const [geosaidalivre, setageosaidalivre] = React.useState({lat:-29.72351683, lng:-53.72809770});
function handlelivre(){

  var unit1 = firebase.firestore().collection("agenda").doc(stid).collection('direcoes').get()
    .then(function(querySnapshot) {
      
      querySnapshot.forEach(function(doc) {
        //agorasaida(doc.id)
      
        var unit = firebase.firestore().collection("agenda").doc(stid).collection('direcoes').doc(doc.id);



        return  unit.update({geodestino:geodestinolivre, geosaida:geosaidalivre})
        .then(() => {
        console.log("locsaliza successfully updated!", props);
        
        })
        .catch((error) => {
          // The document probably doesn't exist.
          console.error("Error updating document: ", error);
        });

          })
    }).catch((error) => {
      // The document probably doesn't exist.
      console.error("Error updating document: ", error);
    });



}

//************************************** */
  return (
    <Card className={classes.root} >
           <CardHeader
             avatar={
               
               <Avatar aria-label="Veículo" className={classes.avatar}>
                <DriveEtaIcon />
               </Avatar>
             }
            
             title= {nsolicitacao}
             subheader= {dsolicitacao}
             action={
              <Tooltip title={"Itinerário"}>
              <IconButton
         className={classes.rounded3}
         onClick={handleClickopenitinerariomapa}
         //disabled={stbtsalvarveiculo}
         //aria-expanded={expanded}
         aria-label="Visualizar documento"
        
       >
         <ExploreIcon />
         
        
       </IconButton>
       </Tooltip>
             }

     
           />
           <CardContent>
           
           
                <Typography variant="body2" color="textSecondary" component="p">
               {campisolicitante}
             </Typography>
             <Typography variant="body2" color="textSecondary" component="p">
               {depsolicitente}
             </Typography>
             <Typography variant="body2" color="textSecondary" component="p">
               Nome Solicitante: {nomesolicitante}
             </Typography>
             <Typography variant="body2" color="textSecondary" component="p">
               {tipodeslocamento}
             </Typography>
             <Typography variant="body2" color="textSecondary" component="p">
               Objetivo: {objetivo}
             </Typography>
             <Typography variant="body2" color="textSecondary" component="p">
               Quilometragem: {kilometragem} 
             </Typography>

             <Typography variant="body2" color="textSecondary" component="p">
               Veículo: {verveiculo.label}
             </Typography>
             <Typography variant="body2" color="textSecondary" component="p">
               Motorista: {vermotorista.label}
             </Typography>
             <Typography variant="body2" color="textSecondary" component="p">
               Telefone Motorista: {vermotorista.telefone}
             </Typography>
             <Typography variant="body2" color="textSecondary" component="p">
               Previsão de custo de rodagem R${stvalorkm}
             </Typography>

                         
             <TextField
            className={classes.datas}
         id="datetimeini2"
        label="Data e hora da Saída"
        disabled={true}
        value={datahorasaida}
        />
         <TextField
             className={classes.datas}
             id="datetimeini"
            label="Data e hora do Retorno"
            disabled={true}
            
            value={datahoraretorno}
            />
            
            <Typography variant="body2" color="textSecondary" component="p">
               Previsão de chegada do retorno: {temporetorno}
             </Typography>
             
            <Dialog  open={openitinerariomapa} variant="outlined" onClose={handleCloseditinerariomapa} aria-labelledby="form-dialog-title" >
        <DialogTitle id="form-dialog-naodep">Itinerário</DialogTitle>
        <DialogContent>
          <DialogContentText>
        
         <Mapdialog   props={stid}/>
          
         </DialogContentText>
            
        </DialogContent>
        <DialogActions>
            
           
          <Button variant="contained" onClick={handleCloseditinerariomapa} color="primary" >
            OK
          </Button>
          </DialogActions>
      </Dialog>

             

           </CardContent>

          
            <CardActions disableSpacing>

           <div hidden={stbtdeferirmento}>
                 
    <Tooltip title={"Indeferir"}>
    <IconButton
      className={classes.rounded2}
      disabled={stbtindeferi}
      onClick={handleindeferir}
      //aria-expanded={expanded}
      aria-label="indeferir"
      
    >
      <EventBusyIcon />
    </IconButton>
  </Tooltip>
   

           </div>

           <div hidden={stbttransferir}>

           <Tooltip title={"Interno Livre"}>
    <IconButton
      className={classes.rounded}
      disabled={stbtindeferi}
      onClick={handlelivre}
      //aria-expanded={expanded}
      aria-label="indeferir"
      
    >
      
      <CenterFocusWeakIcon />
    </IconButton>
  </Tooltip>

           <Tooltip title={"Veiculo e Motorista"}>
           <IconButton
      className={classes.rounded3}
      onClick={handlelotarveiculo}
      disabled={stbtlotar}
      //aria-expanded={expanded}
      aria-label="lotar"
     
    >
      
       <EmojiTransportationIcon />
       </IconButton>
    </Tooltip>

    <Tooltip title={"Repetir Deslocamento"}>
           <IconButton
      className={classes.rounded3}
      onClick={handlerepetirdeslocamento}
      //disabled={stbtlotar}
      //aria-expanded={expanded}
      aria-label="lotar"
     
    >
      
       <HistoryIcon />
       </IconButton>
    </Tooltip>

    <Tooltip title={"Liberar reserva do Veiculo e Motorista"}>
           <IconButton
      className={classes.rounded2}
      onClick={botaoliberarreserva}
     // disabled={stbtlotar}
      //aria-expanded={expanded}
      aria-label="lotar"
     
    >
       <GridOffIcon />
       </IconButton>
    </Tooltip>
             

    <Tooltip title={"Solicitação de Transporte"}>
           <IconButton
      className={classes.rounded3}
      onClick={visualizarsolicitacao}
      //disabled={stbtsalvarveiculo}
      //aria-expanded={expanded}
      aria-label="Visualizar documento"
     
    >
      <AssignmentIcon />
     
    </IconButton>
    </Tooltip>

    <Tooltip title={"Ordem de Trânsito"}>
           <IconButton
      className={classes.rounded3}
      onClick={visualizarordem}
      //disabled={stbtsalvarveiculo}
      //aria-expanded={expanded}
      aria-label="Visualizar documento"
     
    >
      <AssignmentTurnedInIcon />
     
    </IconButton>
    </Tooltip>
   

    
           </div>
           

           
             <IconButton
               className={clsx(classes.expand, {
                 [classes.expandOpen]: expanded,
               })}
               onClick={handleExpandClick}
               aria-expanded={expanded}
               aria-label="Visualizar"
             >
               <ExpandMoreIcon />
             </IconButton>
     
             
     
           </CardActions>
           <Collapse in={expanded} timeout="auto" unmountOnExit>
             <CardContent>
               

             <div hidden={stdivmotora}>
               <Cardselectmotora codunidadetransporte={props.myfila} setavalorescategoriamotorista={setavalorescategoriamotorista}
               setavaloretipoveiculo={setavaloretipoveiculo} setaveiculomotora={setaveiculomotora} setatemporetorno={propsretorno} datahorasaidareal={datahorasaidareal}/>
               
               <Tooltip title={"Salvar Veículo e Motorista"}>
           <IconButton
           
                className={classes.rounded3}
                onClick={handlesalvaveiculomotorista}
                disabled={stbtsalvarveiculo}
                //aria-expanded={expanded}
                aria-label="veiculos"
              
              >
                <SaveIcon />
     
            </IconButton>
            </Tooltip>
                  
             <br></br>
               
               </div>


               <div hidden={stdivrepeticao}>
               
               <FormControl component="fieldset">
      <FormLabel component="legend">Selecione os dias da Semana para Repetir</FormLabel>
      <FormGroup aria-label="position" row>
        
         <FormControlLabel
          value="bottom"
          
          control={
          <Checkbox color="primary"
          
          checked={domingo} 
          onChange={handledom}
          />
          
        }
          label="Dom"
          labelPlacement="bottom"
        />
        <FormControlLabel
          value="bottom"
          control={<Checkbox color="primary"
          checked={segunda} 
          onChange={handleseg}
          />}
          label="Seg"
          labelPlacement="bottom"
        />
        <FormControlLabel
          value="bottom"
          control={<Checkbox color="primary"
          checked={terca} 
          onChange={handleter}
          />}
          label="Ter"
          labelPlacement="bottom"
        />
        <FormControlLabel
          value="bottom"
          control={<Checkbox color="primary"
          checked={quarta} 
          onChange={handlequa}
          />}
          label="Qua"
          labelPlacement="bottom"
        />
        <FormControlLabel
          value="bottom"
          control={<Checkbox color="primary"
          checked={quinta} 
          onChange={handlequi}
          />}
          label="Qui"
          labelPlacement="bottom"
        />
        <FormControlLabel
          value="bottom"
          control={<Checkbox color="primary"
          checked={sexta} 
          onChange={handlesex}
          />}
          label="Sex"
          labelPlacement="bottom"
        />
        <FormControlLabel
          value="bottom"
          control={<Checkbox color="primary"
          checked={sabado} 
          onChange={handlesab}
          />}
          label="Sáb"
          labelPlacement="bottom"
        />
        
      </FormGroup>
    </FormControl>
<br></br>
<br></br>
    <TextField
        id="date"
        label="Repetir Até"
        type="date"
        value={datarepetir}
        onChange={ e=>setadatarepetir(e.target.value)}
        className={classes.textField}
        InputLabelProps={{
          shrink: true,
        }}
      />
      <br></br>
      <br></br>
               <Tooltip title={"Cancelar"}>
           <IconButton
           
                className={classes.rounded2}
                onClick={handlecancelrepet}
                //disabled={stbtsalvarveiculo}
                //aria-expanded={expanded}
                aria-label="veiculos"
              
              >
                <CancelIcon />
                
     
            </IconButton>
            </Tooltip>
               
               <Tooltip title={"Salvar Repetição"}>
           <IconButton
           
                className={classes.rounded3}
               onClick={handlesalvarepetir}
                //disabled={stbtsalvarveiculo}
                //aria-expanded={expanded}
                aria-label="veiculos"
              
              >
                <SaveIcon />
     
            </IconButton>
            </Tooltip>
                  
             <br></br>
             <br></br>
               </div>

               <div hidden={stdivdespesas}>
                

               <Typography variant="body2" color="textSecondary" component="p">
               Responsável pelas Despesas: {nomerespdespesas}
             </Typography>
             <Typography variant="body2" color="textSecondary" component="p">
               Telefone Responsável pelas Despesas: {fonerespdespesas}
             </Typography>
               </div>
               <Typography variant="body2" color="textSecondary" component="p">
              Saída: {localsaida}
               
               
             </Typography>
             <Typography variant="body2" color="textSecondary" component="p">
               Destino: {localdestino}
               
               
             </Typography>


             <Typography variant="body2" color="textSecondary" component="p">
               Nº Passageiros: {npassageiro}
               <br></br>
               {passageiros}
               
             </Typography>

             <Typography variant="body2" color="textSecondary" component="p">
               Observações: {observacao}
             </Typography>
             
              { anexo.map(item=>(
                <Typography variant="body2" color="textSecondary" component="p">
                  Anexo:
                  <br></br>
                <Link  href={item.link} target="_blank" rel="noopener">{item.nome}</Link>
                </Typography>
              ))

              }
               
             <Typography variant="body2" color="textSecondary" component="p">
               Autorizações: 

               </Typography>
                 
                 
               {autorizacoes.map(item=>(
                <Typography variant="body2" color="textSecondary" component="p">
                Nome: {item.nomeassina}
                <br></br>
                Siape: {item.siapeassina}
                <br></br>
                {item.acao}
                <br></br>
              </Typography>
                 
              ))}
             
            
              
     
             </CardContent>
             <CardActions disableSpacing>
           
                
             <IconButton
               className={clsx(classes.expand, {
                 [classes.expandOpen]: expanded,
               })}
               onClick={handleExpandClick}
               aria-expanded={expanded}
               aria-label="Visualizar"
             >
               <ExpandMoreIcon />
             </IconButton>
     
             
     
           </CardActions>
           </Collapse>
         </Card>
  );
}
